
import { Component, Prop, Vue } from 'vue-property-decorator'
import KAMReadOnlyForm from '@/views/kam/forms/KAMReadOnlyForm.vue'
import { booleanLabel, dateLabel, listLabels, personLabel, ReadOnlySection, valueOrDash } from '@/views/kam/forms/kamReadOnlyPresenter'

@Component({
  components: { 'kam-read-only-form': KAMReadOnlyForm }
})
export default class KAM001V1 extends Vue {
  @Prop({ required: true }) answers!: Record<string, any>
  @Prop({ default: () => ({}) }) media!: Record<string, any>
  @Prop({ default: () => [] }) siteManagers!: any[]
  @Prop({ default: () => [] }) projectLeaders!: any[]
  @Prop({ default: () => [] }) constructionWorkers!: any[]
  @Prop({ default: () => [] }) employees!: any[]

  get people () : any[] {
    return [...this.siteManagers, ...this.projectLeaders, ...this.constructionWorkers, ...this.employees]
  }

  get resultOfAccidentLabel () : string {
    const labels: Record<string, string> = {
      1: 'Dodelijk arbeidsongeval',
      2: 'Arbeidsongeval met ziekenhuisopname',
      3: 'Arbeidsongeval met blijvend letsel',
      4: 'Arbeidsongeval zonder blijvend letsel',
      5: 'Bijna-ongeval',
      6: 'Geen arbeidsongeval'
    }
    const value = this.answers?.resultOfAccident
    return value == null || value === '' ? '-' : labels[String(value)] || String(value)
  }

  get sections () : ReadOnlySection[] {
    const answers = this.answers || {}
    return [
      {
        key: 'basis',
        title: 'Basisgegevens',
        fields: [
          { key: 'siteManagerId', label: 'Uitvoerder', value: personLabel(answers.siteManagerId, this.siteManagers) },
          { key: 'projectManagerId', label: 'Projectleider', value: personLabel(answers.projectManagerId, this.projectLeaders) },
          { key: 'dateTimeOfIncident', label: 'Datum van incident', value: dateLabel(answers.dateTimeOfIncident, true) }
        ]
      },
      {
        key: 'betrokkenen',
        title: 'Betrokkenen en getuigen',
        fields: [
          { key: 'woononInvolvedParties', label: 'Betrokken partijen', kind: 'array', value: listLabels(answers.woononInvolvedParties, this.constructionWorkers) },
          { key: 'nonWoononInvolvedParties', label: 'Externe betrokken partijen', kind: 'array', value: listLabels(answers.nonWoononInvolvedParties) },
          { key: 'woononWitnesses', label: 'Getuigen', kind: 'array', value: listLabels(answers.woononWitnesses, this.constructionWorkers) },
          { key: 'nonWoononWitnesses', label: 'Externe getuigen', kind: 'array', value: listLabels(answers.nonWoononWitnesses) }
        ]
      },
      {
        key: 'incident',
        title: 'Incident details',
        fields: [
          { key: 'incidentDescription', label: 'Wat is er gebeurd?', value: valueOrDash(answers.incidentDescription) },
          { key: 'incidentLocation', label: 'Waar is het gebeurd?', value: valueOrDash(answers.incidentLocation) }
        ]
      },
      {
        key: 'gevolgen',
        title: 'Gevolgen en schade',
        fields: [
          { key: 'injuries', label: 'Is er letsel?', value: booleanLabel(answers.injuries) },
          { key: 'woononInjuredPeople', label: 'Personen met letsel', kind: 'array', value: listLabels(answers.woononInjuredPeople, this.constructionWorkers) },
          { key: 'nonWoononInjuredPeople', label: 'Externe personen met letsel', kind: 'array', value: listLabels(answers.nonWoononInjuredPeople) },
          { key: 'injuryDescription', label: 'Wat is het letsel?', value: valueOrDash(answers.injuryDescription) },
          { key: 'materialDamage', label: 'Is er materiaalschade?', value: booleanLabel(answers.materialDamage) },
          { key: 'materialDamageDescription', label: 'Omschrijving van materiaalschade', value: valueOrDash(answers.materialDamageDescription) },
          { key: 'environmentalIncident', label: 'Is er een milieu-incident?', value: booleanLabel(answers.environmentalIncident) },
          { key: 'environmentalIncidentDescription', label: 'Toelichting milieu-incident', value: valueOrDash(answers.environmentalIncidentDescription) },
          { key: 'dangerousSituation', label: 'Was er een gevaarlijke situatie?', value: booleanLabel(answers.dangerousSituation) },
          { key: 'dangerousSituationDescription', label: 'Toelichting gevaarlijke situatie', value: valueOrDash(answers.dangerousSituationDescription) }
        ]
      },
      {
        key: 'nla',
        title: 'Arbeidsongeval en NLA',
        fields: [
          { key: 'resultOfAccident', label: 'Gevolg van arbeidsongeval', value: this.resultOfAccidentLabel },
          { key: 'referenceNLA', label: 'Meldingsnummer NLA', value: valueOrDash(answers.referenceNLA) },
          { key: 'notificationDateNLA', label: 'Datum melding NLA', value: dateLabel(answers.notificationDateNLA) },
          { key: 'kamManagerId', label: 'Contactpersoon intern', value: personLabel(answers.kamManagerId, this.people) }
        ]
      }
    ]
  }
}
